export type Locale = 'ru' | 'en';

const ru = {
  appTitle: 'Калькулятор эффективного радиуса',
  appSubtitle: 'Аппроксимация радиального отклика детектора и расчёт r₅₀, r₉₀, r₉₅ и r₉₉.',
  language: 'Язык',
  help: 'Подробное мемо',
  quickGuide: 'Краткая памятка',
  quickGuideTitle: 'Краткая памятка: выбор модели, метода и определения радиуса',
  import: 'Импорт файла',
  export: 'Экспорт',
  model: 'Математическая модель',
  objective: 'Метод оценки',
  definition: 'Определение радиуса',
  responseFraction: 'Доля накопленного отклика',
  confidence: 'Доверительная вероятность',
  compare: 'Сравнить модели',
  bootstrap: 'Bootstrap',
  reset: 'Сбросить',
  fixedBaseline: 'Фиксировать фон a',
  baselineValue: 'Значение a',
  saturation: 'Экспоненциальное насыщение',
  stretched: 'Обобщённая экспонента',
  double: 'Двойная экспонента',
  weighted: 'Взвешенный МНК',
  unweighted: 'Обычный МНК',
  poisson: 'Пуассоновское правдоподобие',
  sourceDefinition: 'По чистому отклику источника',
  grossDefinition: 'По полному отклику (методика)',
  curveTitle: 'Радиальный отклик и аппроксимация',
  residualTitle: 'Остатки аппроксимации',
  observed: 'Экспериментальные данные',
  fitted: 'Аппроксимирующая кривая',
  confidenceBand: 'Доверительная область',
  asymptote: 'Асимптота I∞',
  effectiveRadius: 'Эффективный радиус',
  radius: 'Радиус',
  response: 'Отклик',
  uncertainty: 'Неопределённость',
  results: 'Результаты',
  data: 'Данные',
  code: 'Код',
  diagnostics: 'Диагностика',
  parameters: 'Параметры',
  parameter: 'Параметр',
  value: 'Значение',
  standardError: 'Стандартная ошибка',
  interval: '95% ДИ',
  status: 'Статус',
  converged: 'Сходимость достигнута',
  warning: 'Расчёт выполнен с предупреждениями',
  failed: 'Расчёт не выполнен',
  iterations: 'Итерации',
  observations: 'Точки',
  rmse: 'RMSE',
  rSquared: 'R²',
  reducedChiSquared: 'χ²/ν',
  aicc: 'AICc',
  bic: 'BIC',
  addRow: 'Добавить строку',
  include: 'Вкл.',
  actions: 'Действия',
  delete: 'Удалить',
  pasteCsv: 'Вставить CSV',
  csvPlaceholder: 'radius_cm,count_rate_cps,count_rate_std_cps\n0,0.43,0.04\n5,2.54,0.08',
  apply: 'Применить',
  cancel: 'Отмена',
  close: 'Закрыть',
  downloadSession: 'Сессия JSON',
  downloadCsv: 'Данные CSV',
  downloadReport: 'Отчёт Markdown',
  copy: 'Копировать',
  copied: 'Скопировано',
  codeLanguage: 'Язык кода',
  modelComparison: 'Сравнение моделей',
  deltaAicc: 'ΔAICc',
  akaikeWeight: 'Вес Акаике',
  bootstrapTitle: 'Bootstrap-интервалы',
  bootstrapSamples: 'Количество выборок',
  run: 'Запустить',
  successfulSamples: 'Успешных выборок',
  selectedRadiusInterval: 'Интервал эффективного радиуса',
  noResult: 'Измените данные или параметры — расчёт обновится автоматически.',
  localOnly: 'Все вычисления выполняются локально в браузере.',
  dataMode: 'Тип данных',
  countRate: 'Скорость счёта',
  rawCounts: 'Число импульсов',
  monteCarlo: 'Монте-Карло',
  radiusUnit: 'Единица радиуса',
  responseUnit: 'Единица отклика',
  sourceCounts: 'Импульсы',
  liveTime: 'Живое время',
  notes: 'Примечания к расчёту',
  notesHint: 'Опишите прибор, радионуклид, энергию линии, толщину и плотность слоя, геометрию, источник данных и любые допущения.',
  formula: 'Формула',
  fitError: 'Ошибка расчёта',
  invalidSession: 'Файл сессии имеет неподдерживаемый формат.',
  compareFailed: 'Не удалось сравнить модели.',
  bootstrapFailed: 'Не удалось выполнить bootstrap-анализ.',
  helpTitle: 'Мемо: математическая методика расчёта',
  pointCount: '{count} точек',
  automaticFit: 'Автоматический пересчёт',
  reportTitle: 'Отчёт по эффективному радиусу',
  generatedAt: 'Сформировано',
  equation: 'Уравнение',
  warnings: 'Предупреждения',
  noWarnings: 'Предупреждений нет.',
  plotHint: 'Масштабирование: колесо мыши. Сброс диапазона: двойной щелчок.',
  residualAbsolute: 'Абсолютные остатки',
  responsePlotAria: 'График радиального отклика',
  residualPlotAria: 'График остатков',
  warning_PLATEAU_NOT_OBSERVED: 'Плато отклика недостаточно представлено данными.',
  warning_EFFECTIVE_RADIUS_EXTRAPOLATED: 'Эффективный радиус расположен за пределами измеренного диапазона.',
  warning_HIGH_PARAMETER_CORRELATION: 'Обнаружена высокая корреляция параметров; оценки могут быть неустойчивыми.',
  warning_INSUFFICIENT_DATA: 'Недостаточно точек для надёжной оценки параметров.',
  warning_INVALID_UNCERTAINTY: 'Некоторые неопределённости отсутствуют или некорректны.',
  warning_MODEL_MISMATCH: 'Остатки указывают на возможное несоответствие модели данным.',
  warning_NON_MONOTONIC_DATA: 'Данные не демонстрируют ожидаемое монотонное насыщение.',
  warning_OPTIMIZER_LIMIT: 'Оптимизатор достиг предельного числа итераций.',

  // Tools hub / shell
  hubTitle: 'ATOMTEX Tools',
  hubSubtitle: 'Браузерные инструменты для спектрометрии и радиометрии. Все вычисления выполняются локально.',
  toolsLabel: 'Инструменты',
  openTool: 'Открыть',
  ercName: 'Калькулятор эффективного радиуса',
  ercSummary: 'Аппроксимация радиального отклика детектора и расчёт r₅₀, r₉₀, r₉₅, r₉₉ с доверительными интервалами.',
  calName: 'Конструктор калибровок активности',
  calSummary: 'Создание и редактирование XML-файлов калибровки активности: геометрии, составы, нуклиды и векторы.',
  spectrumLabName: 'Спектрометрическая лаборатория',
  spectrumLabSummary: 'Интерактивный анализ SPE/ATS: отдельный foreground/background, континуум, фит пиков, идентификация и активность.',
  nuclideLibraryName: 'Конструктор библиотек нуклидов',
  nuclideLibrarySummary: 'Профессиональный редактор библиотек гамма- и рентгеновских линий с импортом IAEA LiveChart.',
  nuclideDecayName: 'Распад нуклидов',
  nuclideDecaySummary: 'Расчёт активности, состава и излучения цепочек распада по данным IAEA LiveChart.',
  energyFitName: 'Преобразователь ENER_TABLE → ENER_FIT',
  energyFitSummary: 'Пакетное преобразование табличной энергетической калибровки SPE в монотонный полином с ZIP-экспортом и диагностикой.',
  aterminalName: 'ATerminal',
  aterminalSummary: 'Терминал для Web Serial, Web Bluetooth, формирования кадров и диагностики протоколов приборов АТОМТЕХ.',

  // Activity Calibration Builder
  calSubtitle: 'Структурный редактор XML-калибровок активности для радиометрических измерений.',
  geometry: 'Геометрия',
  mix: 'Состав',
  nuclide: 'Нуклид',
  density: 'Плотность',
  vector: 'Вектор',
  attrName: 'Имя',
  attrVolume: 'Объём, л',
  attrLeft: 'Левая граница, кэВ',
  attrRight: 'Правая граница, кэВ',
  attrMaxActivity: 'Макс. активность, Бк',
  attrSpectrum: 'Спектр',
  attrBackground: 'Фон',
  attrActivity: 'Активность, Бк',
  attrW: 'w',
  attrN: 'n',
  addGeometry: 'Добавить геометрию',
  addMix: 'Добавить состав',
  addNuclide: 'Добавить нуклид',
  addDensity: 'Добавить плотность',
  addVector: 'Добавить вектор',
  duplicate: 'Дублировать',
  moveUp: 'Выше',
  moveDown: 'Ниже',
  multiply: 'Умножить…',
  divide: 'Разделить…',
  scaleTitle: 'Масштабирование значений',
  scaleMultiplyHint: 'Числовые атрибуты выбранного элемента и вложенных будут умножены на коэффициент.',
  scaleDivideHint: 'Числовые атрибуты выбранного элемента и вложенных будут разделены на коэффициент.',
  factorLabel: 'Коэффициент',
  importXml: 'Импорт XML',
  exportXml: 'Экспорт XML',
  expandAll: 'Развернуть всё',
  collapseAll: 'Свернуть всё',
  calPreview: 'XML',
  calValidation: 'Проверка',
  calGuide: 'Памятка',
  noIssues: 'Замечаний нет — структура корректна.',
  issuesCount: 'Замечаний: {count}',
  calValid: 'Корректно',
  templatesMenu: 'Шаблоны',
  templateCs137: 'Нуклид: Cs-137',
  templateK40: 'Нуклид: K-40',
  emptyCalibration: 'Добавьте геометрию или загрузите XML-файл, чтобы начать.',
  importXmlError: 'Не удалось разобрать XML-файл калибровки.',
  filenameLabel: 'Файл',
  savedLabel: 'Сохранено',
  neverSaved: '—',
  calNotesHint: 'Опишите прибор, геометрию, источник и условия калибровки.',
  noVectors: 'Векторы не заданы.',
  val_volume: 'Объём (volume) должен быть неотрицательным числом.',
  val_left: 'Левая граница (left) должна быть числом.',
  val_right: 'Правая граница (right) должна быть числом.',
  val_maxactivity: 'Макс. активность (maxactivity) должна быть ≥ 0.',
  val_value: 'Значение (value) должно быть числом.',
  val_activity: 'Активность (activity) должна быть ≥ 0.',
  val_w: 'Атрибут w должен быть целым числом > 0.',
  val_n: 'Атрибут n должен быть целым числом > 0.',
  val_interval: 'Интервал [left, right] некорректен: должно быть left < right.',
} as const;

const en: Record<keyof typeof ru, string> = {
  appTitle: 'Effective radius calculator',
  appSubtitle: 'Fit detector radial response and calculate r₅₀, r₉₀, r₉₅ and r₉₉.',
  language: 'Language',
  help: 'Detailed memo',
  quickGuide: 'Quick guide',
  quickGuideTitle: 'Quick guide: choosing the model, method and radius definition',
  import: 'Import file',
  export: 'Export',
  model: 'Mathematical model',
  objective: 'Estimator',
  definition: 'Radius definition',
  responseFraction: 'Accumulated response fraction',
  confidence: 'Confidence level',
  compare: 'Compare models',
  bootstrap: 'Bootstrap',
  reset: 'Reset',
  fixedBaseline: 'Fix baseline a',
  baselineValue: 'Value of a',
  saturation: 'Exponential saturation',
  stretched: 'Generalized exponential',
  double: 'Double exponential',
  weighted: 'Weighted least squares',
  unweighted: 'Ordinary least squares',
  poisson: 'Poisson likelihood',
  sourceDefinition: 'Source-only response',
  grossDefinition: 'Gross response (method)',
  curveTitle: 'Radial response and fitted model',
  residualTitle: 'Fit residuals',
  observed: 'Experimental data',
  fitted: 'Fitted curve',
  confidenceBand: 'Confidence band',
  asymptote: 'Asymptote I∞',
  effectiveRadius: 'Effective radius',
  radius: 'Radius',
  response: 'Response',
  uncertainty: 'Uncertainty',
  results: 'Results',
  data: 'Data',
  code: 'Code',
  diagnostics: 'Diagnostics',
  parameters: 'Parameters',
  parameter: 'Parameter',
  value: 'Value',
  standardError: 'Standard error',
  interval: '95% CI',
  status: 'Status',
  converged: 'Converged',
  warning: 'Completed with warnings',
  failed: 'Fit failed',
  iterations: 'Iterations',
  observations: 'Points',
  rmse: 'RMSE',
  rSquared: 'R²',
  reducedChiSquared: 'χ²/ν',
  aicc: 'AICc',
  bic: 'BIC',
  addRow: 'Add row',
  include: 'Use',
  actions: 'Actions',
  delete: 'Delete',
  pasteCsv: 'Paste CSV',
  csvPlaceholder: 'radius_cm,count_rate_cps,count_rate_std_cps\n0,0.43,0.04\n5,2.54,0.08',
  apply: 'Apply',
  cancel: 'Cancel',
  close: 'Close',
  downloadSession: 'Session JSON',
  downloadCsv: 'Dataset CSV',
  downloadReport: 'Markdown report',
  copy: 'Copy',
  copied: 'Copied',
  codeLanguage: 'Code language',
  modelComparison: 'Model comparison',
  deltaAicc: 'ΔAICc',
  akaikeWeight: 'Akaike weight',
  bootstrapTitle: 'Bootstrap intervals',
  bootstrapSamples: 'Number of samples',
  run: 'Run',
  successfulSamples: 'Successful samples',
  selectedRadiusInterval: 'Effective-radius interval',
  noResult: 'Change the data or settings; the fit updates automatically.',
  localOnly: 'All calculations run locally in your browser.',
  dataMode: 'Data type',
  countRate: 'Count rate',
  rawCounts: 'Raw counts',
  monteCarlo: 'Monte Carlo',
  radiusUnit: 'Radius unit',
  responseUnit: 'Response unit',
  sourceCounts: 'Counts',
  liveTime: 'Live time',
  notes: 'Calculation notes',
  notesHint: 'Describe the instrument, radionuclide, line energy, layer thickness and density, geometry, data source and assumptions.',
  formula: 'Formula',
  fitError: 'Fit error',
  invalidSession: 'The analysis session format is unsupported.',
  compareFailed: 'Model comparison failed.',
  bootstrapFailed: 'Bootstrap analysis failed.',
  helpTitle: 'Memo: mathematical calculation methodology',
  pointCount: '{count} points',
  automaticFit: 'Automatic recalculation',
  reportTitle: 'Effective radius report',
  generatedAt: 'Generated',
  equation: 'Equation',
  warnings: 'Warnings',
  noWarnings: 'No warnings.',
  plotHint: 'Zoom with the mouse wheel. Double-click to reset the axes.',
  residualAbsolute: 'Absolute residuals',
  responsePlotAria: 'Radial response plot',
  residualPlotAria: 'Residual plot',
  warning_PLATEAU_NOT_OBSERVED: 'The response plateau is insufficiently represented by the data.',
  warning_EFFECTIVE_RADIUS_EXTRAPOLATED: 'The effective radius lies beyond the measured range.',
  warning_HIGH_PARAMETER_CORRELATION: 'High parameter correlation was detected; estimates may be unstable.',
  warning_INSUFFICIENT_DATA: 'There are too few observations for a reliable fit.',
  warning_INVALID_UNCERTAINTY: 'Some uncertainties are missing or invalid.',
  warning_MODEL_MISMATCH: 'Residuals indicate a possible model mismatch.',
  warning_NON_MONOTONIC_DATA: 'The data do not show the expected monotonic saturation.',
  warning_OPTIMIZER_LIMIT: 'The optimizer reached its iteration limit.',

  // Tools hub / shell
  hubTitle: 'ATOMTEX Tools',
  hubSubtitle: 'Browser tools for spectrometry and radiometry. Everything runs locally in your browser.',
  toolsLabel: 'Tools',
  openTool: 'Open',
  ercName: 'Effective Radius Calculator',
  ercSummary: 'Fit detector radial response and compute r₅₀, r₉₀, r₉₅, r₉₉ with confidence intervals.',
  calName: 'Activity Calibration Builder',
  calSummary: 'Create and edit activity-calibration XML files: geometries, mixes, nuclides and vectors.',
  spectrumLabName: 'Spectrometry Workbench',
  spectrumLabSummary: 'Interactive SPE/ATS analysis with separate foreground/background, continuum, peak fitting, identification, and activity.',
  nuclideLibraryName: 'Radionuclide Library Builder',
  nuclideLibrarySummary: 'Professional editor of gamma and X-ray line libraries with IAEA LiveChart import.',
  nuclideDecayName: 'Nuclide Decay',
  nuclideDecaySummary: 'Activity, inventory, and emission calculations for IAEA LiveChart decay chains.',
  energyFitName: 'ENER_TABLE → ENER_FIT Converter',
  energyFitSummary: 'Batch conversion of tabulated SPE energy calibration into a monotonic polynomial with ZIP export and diagnostics.',
  aterminalName: 'ATerminal',
  aterminalSummary: 'Web Serial and Web Bluetooth terminal for frame construction and ATOMTEX device protocol diagnostics.',

  // Activity Calibration Builder
  calSubtitle: 'Structured editor for activity-calibration XML used in radiometric measurements.',
  geometry: 'Geometry',
  mix: 'Mix',
  nuclide: 'Nuclide',
  density: 'Density',
  vector: 'Vector',
  attrName: 'Name',
  attrVolume: 'Volume, L',
  attrLeft: 'Left bound, keV',
  attrRight: 'Right bound, keV',
  attrMaxActivity: 'Max activity, Bq',
  attrSpectrum: 'Spectrum',
  attrBackground: 'Background',
  attrActivity: 'Activity, Bq',
  attrW: 'w',
  attrN: 'n',
  addGeometry: 'Add geometry',
  addMix: 'Add mix',
  addNuclide: 'Add nuclide',
  addDensity: 'Add density',
  addVector: 'Add vector',
  duplicate: 'Duplicate',
  moveUp: 'Up',
  moveDown: 'Down',
  multiply: 'Multiply…',
  divide: 'Divide…',
  scaleTitle: 'Scale values',
  scaleMultiplyHint: 'Numeric attributes of the selected element and its descendants will be multiplied by the factor.',
  scaleDivideHint: 'Numeric attributes of the selected element and its descendants will be divided by the factor.',
  factorLabel: 'Factor',
  importXml: 'Import XML',
  exportXml: 'Export XML',
  expandAll: 'Expand all',
  collapseAll: 'Collapse all',
  calPreview: 'XML',
  calValidation: 'Validation',
  calGuide: 'Guide',
  noIssues: 'No issues — the structure is valid.',
  issuesCount: 'Issues: {count}',
  calValid: 'Valid',
  templatesMenu: 'Templates',
  templateCs137: 'Nuclide: Cs-137',
  templateK40: 'Nuclide: K-40',
  emptyCalibration: 'Add a geometry or import an XML file to begin.',
  importXmlError: 'Could not parse the calibration XML file.',
  filenameLabel: 'File',
  savedLabel: 'Saved',
  neverSaved: '—',
  calNotesHint: 'Describe the instrument, geometry, source and calibration conditions.',
  noVectors: 'No vectors defined.',
  val_volume: 'volume must be a non-negative number.',
  val_left: 'left must be a number.',
  val_right: 'right must be a number.',
  val_maxactivity: 'maxactivity must be ≥ 0.',
  val_value: 'value must be a number.',
  val_activity: 'activity must be ≥ 0.',
  val_w: 'w must be an integer > 0.',
  val_n: 'n must be an integer > 0.',
  val_interval: 'Interval [left, right] is invalid: left must be < right.',
};

export type TranslationKey = keyof typeof ru;
export const dictionaries = { ru, en } as const;

export function translate(
  locale: Locale,
  key: TranslationKey,
  values?: Record<string, string | number>,
): string {
  let text = dictionaries[locale][key];
  if (values) {
    for (const [name, value] of Object.entries(values)) {
      text = text.replaceAll(`{${name}}`, String(value));
    }
  }
  return text;
}
